function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("mask", {
  id: "mask0",
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 375,
  height: 160
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0.10867L375 0L374.973 125.123C363.596 140.599 344.518 147.129 317.739 144.712C277.57 141.088 207.046 108.457 127.471 108.457C74.4207 108.457 31.9305 125.638 0 160V0.10867Z",
  fill: "white"
}));

var SvgProfileBg = function SvgProfileBg(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 375 160",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 133.44V156.85L187.5 145.145L0 133.44Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.763 144.97L187.808 144.933L187.725 144.941L187.696 144.962L187.763 144.97Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.204 144.995L375 156.654V133.253L188.787 144.87L188.204 144.995Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.658 144.962L187.675 144.941L187.625 144.945L187.617 144.958L187.658 144.962Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.537 144.949H187.512V144.958H187.537V144.949Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.971 144.983L188.183 144.908L187.925 144.924L187.829 144.974L187.971 144.983Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.583 144.937H187.571V144.97H187.583V144.937Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 185.057V210.145L187.5 145.145L0 185.057Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.5 145.145L188.204 144.995L187.971 144.983L187.5 145.145Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.787 144.87L375 105.234V80.1497L188.183 144.908L188.787 144.87Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.183 144.908L187.97 144.983L188.204 144.995L188.787 144.87L188.183 144.908Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.365 218.714L187.5 145.145L46.0371 218.714H80.365Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.925 144.924L375 47.633V16.3906L187.808 144.933L187.925 144.924Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.763 144.97L187.5 145.145L187.829 144.974L187.763 144.97Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.829 144.975L187.925 144.925L187.808 144.933L187.763 144.97L187.829 144.975Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.774 218.714L187.5 145.145L107.739 218.714H124.774Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.725 144.941L375 -27.7934V-49.8708H353.776L187.675 144.941H187.725Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.658 144.962L187.5 145.145L187.696 144.962H187.658Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.696 144.962L187.725 144.941H187.675L187.658 144.962H187.696Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.135 218.714L187.5 145.145L140.797 218.714H152.135Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.625 144.945L311.291 -49.8708H281.261L187.592 144.945H187.625Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.588 144.958L187.5 145.145L187.617 144.958H187.588Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.617 144.937H187.6V144.97H187.617V144.937Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.022 218.714L187.5 145.145L163.923 218.714H173.022Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.562 144.949L250.001 -49.8708H225.875L187.537 144.949H187.562Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.538 144.958L187.5 145.145L187.563 144.958H187.538Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.554 144.941H187.546V144.966H187.554V144.941Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.752 218.714L187.5 145.145L183.253 218.714H191.752Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.513 144.958L187.5 144.954L187.513 144.949L198.751 -49.8708H176.253L187.5 145.145L187.513 144.958Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.5 144.954L187.513 144.958V144.949L187.5 144.954Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.081 218.714L187.5 145.145L201.978 218.714H211.081Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.129 -49.8708H125.003L187.5 145.145L149.129 -49.8708Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.199 218.714L187.5 145.145L222.869 218.714H234.199Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.7481 -49.8708H63.7092L187.5 145.145L93.7481 -49.8708Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267.266 218.714L187.5 145.145L250.222 218.714H267.266Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2238 -49.8708H0V-27.7976L187.5 145.145L21.2238 -49.8708Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.959 218.714L187.5 145.145L294.635 218.714H328.959Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.3906V47.633L187.5 145.145L0 16.3906Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375 210.145V185.057L187.5 145.145L375 210.145Z",
    style: {
      fill: "var(--color-primary)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 80.1453V105.233L187.5 145.145L0 80.1453Z",
    style: {
      fill: "var(--color-primary)"
    }
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProfileBg, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/profile-bg.7eec32f5.svg";
export { ForwardRef as ReactComponent };